import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=4cf288c9&scoped=true&lang=html&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf288c9",
  null
  
)

export default component.exports